<template>
	<div class="search-form">
		<gc-custom-search
			v-for="item in searchFormItems"
			:key="item.prop"
			class="search"
			:type="item.type"
			:width="item.width"
			:key-word="item.keyWord"
			:filterable="item.filterable"
			:search-option="item.searchOption"
			:search-option-key="item.searchOptionKey"
			:search.sync="params[item.prop]"
			:need-all-for-search="item.needAllForSearch"
			:multiple="item.multiple"
		/>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import { generateSearchFormItems } from './config'

export default {
	name: 'SearchForm',
	data() {
		return {
			params: {},
			searchFormItems: [],
		}
	},
	watch: {
		params: {
			handler(val) {
				this.$emit('params-change', val)
			},
			deep: true,
		},
	},
	async mounted() {
		this.searchFormItems = await this.initSearchFormItems()
		this.params = this.initParams()
	},
	methods: {
		...mapActions({
			getDeviceTypes: 'common/getDeviceTypeList',
		}),
		async initSearchFormItems() {
			const res = await this.getDeviceTypeList()
			const list = this.dealRes(res)
			return generateSearchFormItems(list)
		},
		dealRes(list) {
			return list.map(item => ({ label: item.label, value: item.value }))
		},
		initParams() {
			return {
				eventSwitch: null,
			}
		},
		getDeviceTypeList() {
			return this.getDeviceTypes()
				.then(res => res)
				.catch(() => [])
		},
	},
}
</script>

<style scoped lang="scss">
.search-form {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
}
</style>
